const getters = {
  getServiceRequestList(state) {
    return state.serviceRequestList;
  },
  getServiceRequest(state) {
    return state.serviceRequest;
  },
  getServiceRequestStats(state) {
    return state.serviceRequestStats;
  }
};

export default getters;
